/** Получить отображаемое имя view (moddle может иметь name как string или объект) */
export function getViewLabel(view: {id?: string; name?: string | {value?: string}} | null): string {
	if (!view) return 'View';
	if (typeof view.name === 'string' && view.name.trim()) return view.name;
	if (
		view.name &&
		typeof view.name === 'object' &&
		typeof view.name.value === 'string' &&
		view.name.value.trim()
	)
		return view.name.value;
	return view.id || 'View';
}
